import styled from 'styled-components'

export const Header = styled.header`
    max-width: 880px;
`;
export const Intro = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;
export const Eyebrow = styled.div`
    color: ${({ theme }) => theme.palette.blue.main};
    font-family: Poppins, sans-serif;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
`;
export const Title = styled.h1`
    margin: 0;
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Gilroy, sans-serif;
    font-size: clamp(30px, 3.8vw, 44px);
    font-weight: 700;
    letter-spacing: -0.045em;
    line-height: 1.08;
`;
export const Subtitle = styled.p`
    max-width: 650px;
    margin: 2px 0 0;
    color: ${({ theme }) => theme.palette.colors.muted};
    font-family: Lato, sans-serif;
    font-size: 14px;
    line-height: 1.45;
`;
